/** @jsx jsx */
import React from 'react'

import { Container, jsx } from 'theme-ui'

export default ({ children }) => <Container>{children}</Container>
